import { render, staticRenderFns } from "./TributeSetupForContributors.vue?vue&type=template&id=6853bd39&scoped=true"
import script from "./TributeSetupForContributors.vue?vue&type=script&lang=js"
export * from "./TributeSetupForContributors.vue?vue&type=script&lang=js"
import style0 from "./TributeSetupForContributors.vue?vue&type=style&index=0&id=6853bd39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853bd39",
  null
  
)

export default component.exports